import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportBookDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_3135_7062",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M12 21.12C12 16.3373 12 13.9459 12.9895 12.146C13.7209 10.8157 14.8157 9.72089 16.146 8.98955C17.9459 8 20.3373 8 25.12 8H70.88C75.6627 8 78.0541 8 79.854 8.98955C81.1843 9.72089 82.2791 10.8157 83.0105 12.146C84 13.9459 84 16.3373 84 21.12V82.88C84 87.6627 84 90.0541 83.0105 91.854C82.2791 93.1843 81.1843 94.2791 79.854 95.0105C78.0541 96 75.6627 96 70.88 96H25.12C20.3373 96 17.9459 96 16.146 95.0105C14.8157 94.2791 13.7209 93.1843 12.9895 91.854C12 90.0541 12 87.6627 12 82.88V21.12Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16C10 11.0294 14.0294 7 19 7H76C80.9706 7 85 11.0294 85 16H83C83 12.134 79.866 9 76 9H20C16.6863 9 14 12.134 14 16H10ZM85 88C85 92.9706 80.9706 97 76 97H19C14.0294 97 10 92.9706 10 88H14C14 91.866 16.6863 95 20 95H76C79.866 95 83 91.866 83 88H85ZM19 97C14.0294 97 10 92.9706 10 88V16C10 11.0294 14.0294 7 19 7L20 9C16.6863 9 14 12.134 14 16V88C14 91.866 16.6863 95 20 95L19 97ZM76 7C80.9706 7 85 11.0294 85 16V88C85 92.9706 80.9706 97 76 97V95C79.866 95 83 91.866 83 88V16C83 12.134 79.866 9 76 9V7Z",
			fill: "white",
			fillOpacity: .48,
			mask: "url(#path-1-inside-1_3135_7062)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-2_3135_7062",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M32 55C38.6274 55 44 49.6274 44 43H32V31C25.3726 31 20 36.3726 20 43C20 49.6274 25.3726 55 32 55Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 43H45V42H44V43ZM32 43H31V44H32V43ZM32 31H33V30H32V31ZM43 43C43 49.0751 38.0751 54 32 54V56C39.1797 56 45 50.1797 45 43H43ZM44 42H32V44H44V42ZM33 43V31H31V43H33ZM21 43C21 36.9249 25.9249 32 32 32V30C24.8203 30 19 35.8203 19 43H21ZM32 54C25.9249 54 21 49.0751 21 43H19C19 50.1797 24.8203 56 32 56V54Z",
			fill: "#8588D8",
			mask: "url(#path-3-inside-2_3135_7062)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.5 28.5117C40.4535 28.7664 45.2326 33.5465 45.4873 39.5H34.5V28.5117Z",
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36 40V42H48C48 38.1767 46.212 34.771 43.4265 32.5735C45.0382 34.6164 46 37.1959 46 40H36Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.1431 18.64C38.7722 16.7763 39.5917 13.6592 45.8366 16.1007C53.6427 19.1527 42.066 19.8469 44.1657 18.49C46.2655 17.1331 51.3231 16.4843 56.2411 17.8305",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55 45H74",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 71H51",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55 49H63",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 68H40",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55 40.417L58.9144 39.6474C59.7256 39.4878 60.564 39.5369 61.3511 39.7899L61.8158 39.9392C62.7666 40.2449 63.8004 40.1554 64.6847 39.6909V39.6909C65.5291 39.2473 66.5117 39.145 67.4295 39.4051L71 40.417",
			stroke: "#8588D8",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7138 67.1698C18.7315 69.7925 21.4071 73.0114 24.9904 71.1039C30.5329 68.1535 24.0984 65.0781 22.9654 68.5204",
			stroke: "white",
			strokeOpacity: .48,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.9193 11.8262C12 13.5744 12 15.8434 12 20.3814V21.12C12 16.3373 12 13.946 12.9895 12.146C13.7209 10.8157 14.8157 9.7209 16.146 8.98955C17.9459 8 20.3373 8 25.12 8H70.88C75.6627 8 78.0541 8 79.854 8.98955C80.1326 9.14268 80.4008 9.31175 80.6575 9.49556C80.5126 9.0694 80.3362 8.68416 80.1195 8.3254C79.3218 7.00471 78.1593 5.94287 76.7719 5.26782C74.8938 4.35399 72.4513 4.49558 67.5662 4.77877L24.3607 7.28344C19.8303 7.54607 17.5651 7.67739 15.873 8.69637C14.621 9.45028 13.5995 10.5327 12.9193 11.8262Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.389 1.99455L23.3073 7.30102C23.1429 7.32589 22.9822 7.35021 22.8249 7.37406C19.295 7.59036 17.3621 7.79965 15.873 8.69636C14.621 9.45027 13.5995 10.5327 12.9193 11.8262C12 13.5744 12 15.8434 12 20.3814V19.2847C12 15.1152 12 13.0305 12.8126 11.368C13.4147 10.1359 14.3235 9.07938 15.4516 8.29971C16.9739 7.24765 19.0352 6.93586 23.1578 6.31227L58.2395 1.00579C63.0631 0.27617 65.4749 -0.0886414 67.4257 0.644656C68.8668 1.18639 70.1211 2.13247 71.0378 3.36936C71.306 3.7312 71.5308 4.12784 71.7248 4.57617C71.3808 4.58469 71.0189 4.59764 70.6372 4.61412C70.5143 4.37641 70.3809 4.16242 70.2345 3.96482C69.4323 2.88254 68.3348 2.05472 67.0738 1.58071C66.286 1.28455 65.3554 1.18811 63.9724 1.27468C62.5766 1.36204 60.8185 1.62707 58.389 1.99455Z",
			fill: "white",
			fillOpacity: .48
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 73.9759C14.0088 73.9752 14.0175 73.9744 14.0263 73.9737C15.2505 73.8671 16.4907 73.424 17.3755 72.4171C17.5578 72.2096 17.5374 71.8937 17.33 71.7114C17.1226 71.5291 16.8067 71.5495 16.6244 71.757C15.9725 72.4988 15.0316 72.8713 14 72.9719V73.9759ZM14 63.9759C14.0088 63.9752 14.0175 63.9744 14.0263 63.9737C15.2505 63.8671 16.4907 63.424 17.3755 62.4171C17.5578 62.2096 17.5374 61.8937 17.33 61.7114C17.1226 61.5291 16.8067 61.5495 16.6244 61.757C15.9725 62.4988 15.0316 62.8713 14 62.9719V63.9759ZM14 36.9759C14.0088 36.9752 14.0175 36.9745 14.0263 36.9737C15.2505 36.8672 16.4907 36.424 17.3755 35.4171C17.5578 35.2096 17.5374 34.8937 17.33 34.7114C17.1226 34.5291 16.8067 34.5495 16.6244 34.757C15.9725 35.4988 15.0316 35.8712 14 35.9719V36.9759ZM14 25.9759C14.0088 25.9752 14.0175 25.9744 14.0263 25.9737C15.2505 25.8671 16.4907 25.424 17.3755 24.4171C17.5578 24.2096 17.5374 23.8937 17.33 23.7114C17.1226 23.5291 16.8067 23.5495 16.6244 23.757C15.9725 24.4988 15.0316 24.8712 14 24.9719V25.9759ZM12 63.8738V62.8559C11.6157 62.7778 11.2506 62.6715 10.9208 62.5456C10.4908 62.3814 10.1373 62.1902 9.88581 61.999C9.62182 61.7982 9.5259 61.6405 9.50472 61.5612C9.49702 61.5324 9.5003 61.5202 9.50347 61.5114C9.50802 61.4988 9.52645 61.4591 9.59706 61.3999C9.7492 61.2724 10.0717 61.1151 10.6671 60.9893C10.9373 60.9322 11.11 60.6669 11.0529 60.3967C10.9958 60.1265 10.7305 59.9538 10.4603 60.0109C9.80418 60.1496 9.29238 60.3505 8.95472 60.6335C8.78043 60.7795 8.64009 60.9581 8.56293 61.1718C8.48438 61.3893 8.483 61.6113 8.53862 61.8194C8.64408 62.214 8.9467 62.5411 9.28052 62.795C9.62684 63.0583 10.0705 63.2914 10.5641 63.4798C10.9994 63.646 11.4865 63.7824 12 63.8738ZM12 36.8738V35.8559C11.6157 35.7778 11.2506 35.6715 10.9208 35.5456C10.4908 35.3814 10.1373 35.1902 9.88581 34.999C9.62182 34.7982 9.5259 34.6405 9.50472 34.5612C9.49702 34.5324 9.5003 34.5202 9.50347 34.5114C9.50802 34.4988 9.52645 34.4591 9.59706 34.3999C9.7492 34.2724 10.0717 34.1151 10.6671 33.9893C10.9373 33.9322 11.11 33.6669 11.0529 33.3967C10.9958 33.1265 10.7305 32.9538 10.4603 33.0109C9.80418 33.1496 9.29238 33.3505 8.95472 33.6335C8.78043 33.7795 8.64009 33.9581 8.56293 34.1718C8.48438 34.3893 8.483 34.6113 8.53862 34.8194C8.64408 35.214 8.9467 35.5411 9.28052 35.795C9.62684 36.0583 10.0705 36.2914 10.5641 36.4798C10.9994 36.646 11.4865 36.7824 12 36.8738ZM12 25.8738V24.8559C11.6157 24.7778 11.2506 24.6715 10.9208 24.5456C10.4908 24.3814 10.1373 24.1902 9.88581 23.999C9.62182 23.7982 9.5259 23.6405 9.50472 23.5612C9.49702 23.5324 9.5003 23.5202 9.50347 23.5114C9.50802 23.4988 9.52645 23.4591 9.59706 23.3999C9.7492 23.2724 10.0717 23.1151 10.6671 22.9893C10.9373 22.9322 11.11 22.6669 11.0529 22.3967C10.9958 22.1265 10.7305 21.9538 10.4603 22.0109C9.80418 22.1496 9.29238 22.3505 8.95472 22.6335C8.78043 22.7795 8.64009 22.9581 8.56293 23.1718C8.48438 23.3893 8.483 23.6112 8.53862 23.8194C8.64408 24.214 8.9467 24.5411 9.28052 24.795C9.62684 25.0583 10.0705 25.2914 10.5641 25.4798C10.9994 25.646 11.4865 25.7824 12 25.8738ZM12 73.8738V72.8559C11.6157 72.7778 11.2506 72.6715 10.9208 72.5456C10.4908 72.3814 10.1373 72.1902 9.88581 71.999C9.62182 71.7982 9.5259 71.6405 9.50472 71.5612C9.49702 71.5324 9.5003 71.5202 9.50347 71.5114C9.50802 71.4988 9.52645 71.4591 9.59706 71.3999C9.7492 71.2724 10.0717 71.1151 10.6671 70.9893C10.9373 70.9322 11.11 70.6669 11.0529 70.3967C10.9958 70.1265 10.7305 69.9538 10.4603 70.0109C9.80418 70.1496 9.29238 70.3505 8.95472 70.6335C8.78043 70.7795 8.64009 70.9581 8.56293 71.1718C8.48438 71.3893 8.483 71.6113 8.53862 71.8194C8.64408 72.214 8.9467 72.5411 9.28052 72.795C9.62684 73.0583 10.0705 73.2914 10.5641 73.4798C10.9994 73.646 11.4865 73.7824 12 73.8738Z",
			fill: "white",
			fillOpacity: .48
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84 24H86C87.1046 24 88 24.8954 88 26V30C88 31.1046 87.1046 32 86 32H84V24Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84 42H85C85.5523 42 86 42.4477 86 43V46C86 46.5523 85.5523 47 85 47H84V42Z",
			fill: "white",
			fillOpacity: .48
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84 66H86C86.5523 66 87 66.4477 87 67V77C87 77.5523 86.5523 78 86 78H84V66Z",
			fill: "white",
			fillOpacity: .48
		})
	]
});
export default SvgReportBookDark;
